import { render, staticRenderFns } from "./home-page-select.vue?vue&type=template&id=5f656db5&"
import script from "./home-page-select.vue?vue&type=script&lang=js&"
export * from "./home-page-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "home-page-select.vue"
export default component.exports